module.exports = __webpack_public_path__ + "img/bullseye-round-purple-highres.e68811d1.png";